<template>
  <!-- Listing -->
  <div class="custom-wrapper">
    <z-table
      ref="activityTable"
      :value="activityMembers"
      :columns="tableColumns"
      :isSingleRowDetail="false"
      class="table table-bordered table-striped"
      detailColumnClass="z-column-60-center"
      sortBy="LastName"
      orderBy="asc"
      :loading="isLoading"
      :isAllChecked="isAllChecked"
      @sort="setOrder"
      @checkedAll="checkedAll"
    >
      <template v-slot:tbody="props">
        <td class="z-column-60-center" style="vertical-align: middle">
          <input
            type="checkbox"
            :id="props.row.user_id"
            :checked="props.row.checked"
            @change="memberChecked"
            class="z-checkbox-small-centered"
          />
        </td>
        <td class="z-column-60" data-attribute="ignore">
          <a href="#" @click="showChart(props.row)">chart</a>
        </td>
        <th scope="row" class="z-column-hide">
          {{ props.row.user_id }}
        </th>
        <td class="z-column-180-min">
          <member-record
            :name="props.row.name"
            :avatar="props.row.avatar"
            :id="props.row.user_id"
            @clicked="memberClick"
          />
        </td>
        <td class="z-column-hide">{{ props.row.email }}</td>
        <td
          v-for="(week, idx) of props.row.progress"
          :key="idx"
          class="z-column-right"
        >
          {{ week.progress }}
        </td>
        <td class="z-column-120-right-min">
          {{ props.row.average.toFixed(1) }}
        </td>
      </template>
      <template v-slot:empty> Nothing found! </template>
    </z-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import MemberRecord from '@/Components/UserCardio/elements/member'
import globals from '@/Plugins/globals'
export default {
  name: 'analyze-activity',
  components: {
    ZTable,
    MemberRecord,
  },
  data() {
    return {
      isLoading: false,
      sortby: null,
      sortdir: null,
    }
  },
  async mounted() {
    await this.reload()
  },
  computed: {
    ...mapGetters('reporting', [
      'analysis',
      'activityProgress',
      'isAllChecked',
      'members',
    ]),
    ...mapGetters('organizations', ['examineOrganization']),
    tableColumns() {
      let _columns = [
        {
          field: 'user_id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
          isFilter: false,
          isCheckAll: true,
          type: 'string',
        },
        {
          field: 'user_id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
          attribute: 'ignore',
        },
        {
          field: 'user_id',
          label: 'Id',
          sortable: false,
          class: 'z-column-hide',
        },
        {
          field: 'LastName',
          label: 'Name',
          sortable: true,
          class: 'z-column-180-min',
        },
        {
          field: 'email',
          label: 'Email',
          sortable: false,
          class: 'z-column-hide',
        },
      ]
      this.weeks.forEach((element) => {
        _columns.push({
          field: 'week',
          label: element,
          sortable: false,
          class: 'z-column-center',
        })
      })
      _columns.push({
        field: 'average',
        label: 'Average',
        sortable: true,
        class: 'z-column-140-center-min',
      })
      return _columns
    },
    weeks() {
      let _data = []
      if (this.activityMembers) {
        let lastId = null
        this.activityMembers.forEach((element) => {
          if (element.user_id !== lastId) {
            if (_data.length < element.progress.length) {
              _data = []
              element.progress.forEach((item) => {
                _data.push(item.week)
              })
            }
          }
          lastId = element.user_id
        })
      }
      return _data
    },
    activityMembers() {
      let _data = null
      this.headerWeeks = []
      if (this.activityProgress) {
        if (this.activityProgress.length > 0) {
          this.isLoading = true
          _data = []
          let clone = JSON.parse(JSON.stringify(this.activityProgress))
          clone.sort(function (a, b) {
            var c = new Date(a.StartDate)
            var d = new Date(b.StartDate)
            return c - d
          })
          // clone = globals.sortByDate(clone, 'progress_date', 'asc')
          let earliest = moment(clone[0].StartDate)
            .isoWeekday(1)
            .startOf('week')
            .add(1, 'days')
          let latest = moment(clone[clone.length - 1].StartDate)
            .isoWeekday(1)
            .startOf('week')
            .add(1, 'days')
          while (earliest.isSameOrBefore(latest)) {
            this.headerWeeks.push(earliest.format('MM/DD/YYYY'))
            earliest.add(7, 'days')
          }
          let lastId = null
          let member = {
            user_id: null,
            name: null,
            progress: [],
          }
          this.activityProgress.forEach((element) => {
            if (element.user_id !== lastId) {
              if (lastId !== null) {
                _data.push(member)
                member = {
                  user_id: null,
                  name: null,
                  progress: [],
                }
              }
              let name = element.LastName
              if (element.NickName !== '') {
                name += `, ${element.FirstName} (${element.NickName})`
              } else {
                name += `, ${element.FirstName}`
              }
              member.user_id = element.user_id
              member.name = name
              member.avatar = element.Avatar
              member.email = element.email
              let filtered = this.activityProgress.filter(
                (x) => x.user_id === element.user_id
              )
              if (filtered) {
                this.headerWeeks.forEach((week) => {
                  let found = filtered.find((x) =>
                    moment(x.StartDate)
                      .isoWeekday(1)
                      .startOf('week')
                      .add(1, 'days')
                      .isSame(week)
                  )
                  if (found) {
                    member.progress.push({
                      week: week,
                      progress: found.Percent
                        ? found.Percent !== ''
                          ? found.Percent.toFixed(1)
                          : (0.0).toFixed(1)
                        : (0.0).toFixed(1),
                    })
                  } else {
                    member.progress.push({
                      week: week,
                      progress: (0.0).toFixed(1),
                    })
                  }
                })
              }
            }
            lastId = element.user_id
          })
          _data.push(member)
          _data.forEach((member) => {
            member.average = this.calcTotal(member.progress)
            let found = this.members.find(
              (x) => parseInt(x.user_id) === parseInt(member.user_id)
            )
            if (found) {
              member.checked = found.checked
            }
          })
          if (this.sortby !== null && this.sortdir !== null) {
            _data = globals.sortArray(_data, this.sortby, this.sortdir)
          }
          this.isLoading = false
        }
      }
      return _data
    },
  },
  methods: {
    ...mapActions('global', ['setReload']),
    ...mapActions('reporting', [
      'getActivityProgress',
      'resetData',
      'setChecked',
    ]),
    async setOrder(column, order) {
      this.sortby = column.field
      this.sortdir = order
      await this.reload()
    },
    calcTotal(progress) {
      let total = 0
      let cnt = 0
      let avg = 0
      if (progress) {
        cnt = progress.length
        progress.forEach((element) => {
          if (element.progress) {
            total += parseFloat(element.progress)
          }
        })
        if (cnt > 0) {
          avg = total / cnt
        }
      }
      return parseFloat(avg.toFixed(1))
    },
    memberClick(id) {
      this.$emit('memberClick', id)
    },
    async reload() {
      this.setReload(true)
      this.resetData({ name: 'activity' })
      let start = moment(this.analysis.startDate)
      let end = moment(this.analysis.endDate)
      if (end.diff(start, 'years') < 2) {
        this.isLoading = true
        await this.getActivityProgress({
          orgId: this.examineOrganization.id,
          challengeId: this.analysis.challengeId,
          startDate: this.analysis.startDate,
          endDate: this.analysis.endDate,
          sortby: this.sortby,
          sortdir: this.sortdir,
          search: this.analysis.search,
        })
        this.setReload(false)
        this.isLoading = false
      } else {
        this.setReload(false)
        alert('Please keep your date range less than two years.')
      }
    },
    download() {
      var filename = `activity_results_${new Date().toLocaleDateString()}.csv`
      globals.downloadTableAsCsv(this.$refs.activityTable.$el, filename)
    },
    showChart(data) {
      this.$emit('showChart', {
        name: 'activity',
        data: data,
      })
    },
    anyChecked() {
      let _any = false
      if (this.members) {
        if (this.members.length > 0) {
          for (let i = 0; i < this.members.length; i++) {
            if (this.members[i].checked) {
              _any = true
              break
            }
          }
        }
      }
      return _any
    },
    checkedAll(data) {
      console.log('Check All Clicked')
      this.setChecked({
        area: 'activity',
        action: 'all',
        checked: data,
      })
      this.$emit('checked', data)
    },
    memberChecked(e) {
      this.$nextTick(() => {
        let data = {
          user_id: parseInt(e.srcElement.id),
          checked: e.srcElement.checked,
        }
        this.setChecked({
          area: 'activity',
          action: 'member',
          checked: data,
        })
        this.$emit('checked', this.anyChecked())
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow: auto;
  max-height: 65vh;
  width: 100%;
}
</style>
